export default class FinesseSizeGuideButton extends HTMLElement {
  active: boolean = false
  tag: string = this.getAttribute('data-tag') || ''
  button: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.button = this.querySelector<HTMLElement>('button[data-button]') as HTMLElement

    (window as any).addEventListener('sizeguide:toggle', this.handleSizeGuide.bind(this))
    this.button.addEventListener('click', this.handleClick.bind(this))
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleSizeGuide(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    window.dispatchEvent(new CustomEvent('sizeguide:toggle', { bubbles: true, detail: { active: !this.isActive, tag: this.tag } }))
  }

  toggle() {
    if (this.isActive) {
      this.button?.classList.add('lowercase')
    } else {
      this.button?.classList.remove('lowercase')
    }
  }
}

customElements.define('finesse-sizeguide-button', FinesseSizeGuideButton)
